<app-header></app-header>

<div class="flex">
    <app-sidebar optionMenu="10"></app-sidebar>
    <main class="flex-1 p-6">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 h-[calc(100vh-80px)]">

            <div
                class="bg-white shadow-lg rounded-2xl p-6 border border-gray-100 sticky top-6 self-start max-h-[calc(102vh-120px)] overflow-y-auto">
                <div class="flex justify-between items-center mb-6">
                    <h2 class="text-xl font-semibold text-gray-800">
                        {{ editingId ? 'Editar Autor' : 'Nuevo Autor' }}
                    </h2>
                </div>
                <form [formGroup]="authorForm" (ngSubmit)="onSubmit()" class="space-y-6">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div class="relative">
                            <input type="text" placeholder="* Nombre" formControlName="nombre"
                                class="w-full rounded-lg bg-gray-50 border p-3">
                            <div *ngIf="(authorForm.get('nombre')?.touched || authorForm.get('nombre')?.dirty) && authorForm.get('nombre')?.invalid"
                                class="absolute left-0 top-full text-red-500 text-sm mt-1">
                                El nombre es obligatorio
                            </div>
                        </div>

                        <div class="relative">
                            <input type="text" placeholder="* Cargo" formControlName="cargo"
                                class="w-full rounded-lg bg-gray-50 border p-3">
                            <div *ngIf="authorForm.get('cargo')?.touched && authorForm.get('cargo')?.invalid"
                                class="absolute left-0 top-full text-red-500 text-sm mt-1">
                                El cargo es obligatorio
                            </div>
                        </div>
                    </div>


                    <input type="email" placeholder="* Correo" formControlName="email"
                        class="w-full rounded-lg bg-gray-50 border p-3">
                    <div *ngIf="authorForm.get('email')?.touched && authorForm.get('email')?.invalid"
                        class="text-red-500 text-sm">
                        El correo es obligatorio
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input type="text" placeholder="Facebook" formControlName="facebook"
                            class="w-full rounded-lg bg-gray-50 border p-3">
                        <input type="text" placeholder="Twitter" formControlName="twitter"
                            class="w-full rounded-lg bg-gray-50 border p-3">
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input type="text" placeholder="Instagram" formControlName="instagram"
                            class="w-full rounded-lg bg-gray-50 border p-3">
                    </div>

                    <div class="relative">
                        <textarea placeholder="* Descripción" formControlName="descripcion" (input)="updateCharCount()"
                            maxlength="2500" class="w-full rounded-lg bg-gray-50 border p-3 resize-y"></textarea>

                        <!-- contador de caracteres -->
                        <div class="flex justify-between text-xs mt-1 text-gray-500">
                            <span>{{ descripcionLength }}/2500</span>
                            <span *ngIf="2500 - descripcionLength > 0">
                                Restantes: {{ 2500 - descripcionLength }}
                            </span>
                        </div>

                        <div *ngIf="authorForm.get('descripcion')?.touched && authorForm.get('descripcion')?.invalid"
                            class="text-red-500 text-sm">
                            La descripción es obligatoria
                        </div>
                    </div>


                    <div
                        class="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center border-2 border-dashed rounded-xl p-4 text-gray-500">
                        <div class="flex flex-col items-center sm:items-start">
                            <span class="text-sm mb-2">* Arrastra o selecciona una foto</span>
                            <input type="file" (change)="onFileSelected($event)" class="text-sm" />
                            <div *ngIf="authorForm.get('ruta_foto')?.touched && authorForm.get('ruta_foto')?.invalid"
                                class="text-red-500 text-sm">
                                La imagen es obligatoria
                            </div>
                        </div>
                        <div *ngIf="previewUrl" class="flex justify-center sm:justify-end">
                            <img [src]="previewUrl" alt="Preview" class="w-24 h-24 rounded-full object-cover shadow-md">
                        </div>
                    </div>

                    <div class="flex justify-end gap-3">
                        <button *ngIf="editingId" type="button" (click)="cancelEdit()"
                            class="px-6 py-3 rounded-xl bg-gray-200 text-gray-700 font-semibold shadow hover:bg-gray-300 transition">
                            Cancelar edición
                        </button>

                        <button type="submit" [disabled]="uploading || authorForm.invalid" class="px-6 py-3 rounded-xl font-semibold shadow-lg transition
         text-white
         bg-purple-purple6 enabled:hover:opacity-90
         disabled:opacity-50 disabled:cursor-not-allowed">
                            {{ editingId ? 'Actualizar Autor' : 'Guardar Autor' }}
                        </button>

                    </div>

                </form>
            </div>

            <div class="overflow-y-auto pr-2 max-h-[calc(100vh-120px)]">
                <h2 class="text-xl font-semibold text-gray-800 mb-2 flex items-center gap-2">
                  <span class="material-icons">Autores</span>
                </h2>
              
                <!-- 🔍 Buscador -->
                <div class="mb-6">
                  <input 
                    type="text" 
                    [(ngModel)]="searchTerm" 
                    (input)="filterAuthors()" 
                    placeholder="Buscar autor por nombre o apellido..." 
                    class="w-[98%] relative left-2 rounded-lg bg-gray-50 border p-3 shadow-sm focus:ring-2 focus:ring-purple-400 outline-none"
                  />
                </div>
              
                <div *ngIf="!loading && errorMsg" class="text-red-500">
                  {{ errorMsg }}
                </div>
              
                <div *ngIf="!loading && !errorMsg && filteredAuthors.length === 0" class="text-gray-500">
                  No hay autores que coincidan con la búsqueda.
                </div>
              
                <div *ngIf="!loading && !errorMsg && filteredAuthors.length > 0" class="grid grid-cols-1 sm:grid-cols-2 gap-6 relative bottom-2">
                  <div *ngFor="let author of filteredAuthors"
                    class="bg-white shadow-md rounded-2xl p-4 text-center relative group hover:shadow-xl transition">
              
                    <div class="flex justify-center">
                      <img [src]="author.ruta_foto" alt="Foto autor"
                        class="w-24 h-24 rounded-full object-cover border-4 border-gray-200 shadow-md">
                    </div>
              
                    <div class="mt-3">
                      <h3 class="text-lg font-bold text-gray-800">{{ author.nombre }}</h3>
                      <span
                        class="inline-block mt-1 px-3 py-1 text-sm rounded-full bg-blue-100 text-purple-purple6 font-medium">
                        {{ author.cargo }}
                      </span>
                    </div>
              
                    <div class="flex justify-center gap-3 mt-4 opacity-0 group-hover:opacity-100 transition">
                      <button class="bg-blue-100 rounded-full p-2 shadow hover:bg-blue-200"
                        (click)="editAuthor(author)" title="Editar">
                        <span class="material-icons text-blue-600">Editar</span>
                      </button>
                      <button class="bg-fuchsia-100 rounded-full p-2 shadow hover:bg-fuchsia-200"
                        (click)="previewAuthor(author)" title="Ver más">
                        <span class="material-icons text-fuchsia-600">Ver información</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
        </div>
    </main>
</div>